import React from 'react';
import { motion } from 'framer-motion';
import { Info, ArrowRight, Target, Lightbulb, Users } from 'lucide-react';
import { Badge } from '../components/Badge';
export function About() {
  return <div className="w-full" data-id="element-244">
      {/* Hero Section */}
      <section className="pt-24 pb-20 bg-gradient-to-b from-white via-slate-50 to-indigo-50/30" data-id="element-245">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-246">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-247">
            <Badge icon={<Info className="w-3.5 h-3.5" data-id="element-249" />} text="ABOUT US" data-id="element-248" />

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black leading-[1.1] tracking-tight mb-10" data-id="element-250">
              Building the Future of <br className="hidden md:block" data-id="element-251" />
              <span className="text-brand-blue" data-id="element-252">Digital</span>{' '}
              <span className="text-brand-purple" data-id="element-253">Business</span>
            </h1>

            <div className="space-y-6 text-lg md:text-xl text-slate-600 leading-relaxed max-w-3xl mx-auto" data-id="element-254">
              <p data-id="element-255">
                At{' '}
                <strong className="text-slate-900" data-id="element-256">Akios Edge Pvt. Ltd.</strong>
                , we help businesses turn ideas into scalable digital solutions
                through technology, creativity, and innovation. Founded in 2025,
                our team brings together expertise in design, engineering,
                analytics, and SaaS growth.
              </p>
              <p data-id="element-257">
                We specialize in creating modern digital experiences, building
                end-to-end products, enabling SaaS growth, and delivering
                data-driven insights that help businesses move faster and
                smarter. Alongside our services, we're building{' '}
                <strong className="text-slate-900" data-id="element-258">Akios BOS</strong>, an
                AI-powered business operating system designed to simplify and
                streamline business operations.
              </p>
              <p className="font-medium text-slate-800 text-xl md:text-2xl pt-4" data-id="element-259">
                At Akios Edge, we believe great technology should feel simple,
                powerful, and human.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mt-12 justify-center w-full" data-id="element-260">
              <button className="bg-brand-blue hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg shadow-blue-600/20 flex items-center justify-center gap-2 group" data-id="element-261">
                Work With Us
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-262" />
              </button>
              <button className="bg-white border border-slate-200 hover:bg-slate-50 text-slate-800 px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-sm" data-id="element-263">
                Explore Akios BOS
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-24 bg-white" data-id="element-264">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-265">
          <div className="grid md:grid-cols-3 gap-8" data-id="element-266">
            {[{
            icon: Target,
            title: 'Mission Driven',
            desc: 'We are obsessed with solving real business problems through elegant technology.'
          }, {
            icon: Lightbulb,
            title: 'Innovation First',
            desc: 'We constantly explore new paradigms in AI and engineering to keep our clients ahead.'
          }, {
            icon: Users,
            title: 'Human Centric',
            desc: 'Behind every screen is a person. We design systems that empower people, not replace them.'
          }].map((value, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="p-8 rounded-2xl bg-slate-50 border border-slate-100 text-center" data-id="element-267">
                <div className="w-14 h-14 mx-auto bg-white rounded-2xl shadow-sm flex items-center justify-center mb-6 text-brand-blue" data-id="element-268">
                  <value.icon className="w-7 h-7" data-id="element-269" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-270">{value.title}</h3>
                <p className="text-slate-600" data-id="element-271">{value.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}